import { fhLog } from './feature_hub_config';
import { SSEResultState } from './models';
import { Readyness } from './featurehub_repository';
export class FeatureHubEventSourceClient {
    constructor(config, repository) {
        this._config = config;
        this._repository = repository;
    }
    init() {
        const options = {};
        if (this._header) {
            options.headers = {
                'x-featurehub': this._header
            };
        }
        fhLog.log('listening at ', this._config.url());
        this.eventSource = FeatureHubEventSourceClient.eventSourceProvider(this._config.url(), options);
        [SSEResultState.Features, SSEResultState.Feature, SSEResultState.DeleteFeature,
            SSEResultState.Bye, SSEResultState.Failure, SSEResultState.Ack].forEach((name) => {
            const fName = name.toString();
            this.eventSource.addEventListener(fName, e => {
                try {
                    const data = JSON.parse(e.data);
                    fhLog.trace(`received ${fName}`, data);
                    this._repository.notify(name, data);
                }
                catch (e) {
                    fhLog.error(JSON.stringify(e));
                }
            });
        });
        this.eventSource.onerror = (e) => {
            if (this._repository.readyness !== Readyness.Ready) {
                fhLog.error('Connection failed and repository not in ready state indicating persistent failure', e);
                this._repository.notify(SSEResultState.Failure, null);
            }
            else {
                fhLog.trace('refreshing connection in case of staleness');
            }
        };
    }
    close() {
        if (this.eventSource != null) {
            const es = this.eventSource;
            this.eventSource = undefined;
            es.close();
        }
    }
    clientEvaluated() {
        return this._config.clientEvaluated();
    }
    contextChange(header) {
        this._header = header;
        if (this.eventSource !== undefined) {
            this.close();
        }
        this.init();
        return Promise.resolve(undefined);
    }
    poll() {
        if (this.eventSource === undefined) {
            this.init();
        }
        return new Promise((resolve) => resolve());
    }
    requiresReplacementOnHeaderChange() {
        return true;
    }
}
FeatureHubEventSourceClient.eventSourceProvider = (url, dict) => {
    const realUrl = dict.headers && dict.headers['x-featurehub'] ?
        url + '?xfeaturehub=' + encodeURI(dict.headers['x-featurehub']) : url;
    return new EventSource(realUrl, dict);
};
//# sourceMappingURL=featurehub_eventsource.js.map